var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14C1 15.7072 1.33625 17.3977 1.98957 18.9749C2.64288 20.5521 3.60045 21.9852 4.80761 23.1924C6.01477 24.3995 7.44788 25.3571 9.02512 26.0104C10.6023 26.6637 12.2928 27 14 27C15.7072 27 17.3977 26.6637 18.9749 26.0104C20.5521 25.3571 21.9852 24.3995 23.1924 23.1924C24.3995 21.9852 25.3571 20.5521 26.0104 18.9749C26.6637 17.3977 27 15.7072 27 14C27 12.2928 26.6637 10.6023 26.0104 9.02512C25.3571 7.44788 24.3995 6.01477 23.1924 4.80761C21.9852 3.60045 20.5521 2.64288 18.9749 1.98957C17.3977 1.33626 15.7072 1 14 1C12.2928 1 10.6023 1.33626 9.02512 1.98957C7.44788 2.64288 6.01477 3.60045 4.80761 4.80761C3.60045 6.01477 2.64288 7.44788 1.98957 9.02512C1.33625 10.6023 1 12.2928 1 14Z",
    stroke: "#03212B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0444 9.66623C17.7827 9.21233 17.4026 8.83814 16.9446 8.5837C16.4866 8.32926 15.968 8.20416 15.4444 8.22179H12.5555C11.7893 8.22179 11.0545 8.52615 10.5128 9.06792C9.97099 9.6097 9.66663 10.3445 9.66663 11.1107C9.66663 11.8769 9.97099 12.6117 10.5128 13.1534C11.0545 13.6952 11.7893 13.9996 12.5555 13.9996H15.4444C16.2106 13.9996 16.9454 14.3039 17.4872 14.8457C18.0289 15.3875 18.3333 16.1223 18.3333 16.8885C18.3333 17.6546 18.0289 18.3894 17.4872 18.9312C16.9454 19.473 16.2106 19.7773 15.4444 19.7773H12.5555C12.0319 19.795 11.5133 19.6699 11.0553 19.4154C10.5974 19.161 10.2172 18.7868 9.95551 18.3329M14 6.77734V21.2218",
    stroke: "#03212B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq2);
export default __webpack_public_path__ + "static/media/faq2.bd94340940f61c5eed477f24b1b1d65b.svg";
export { ForwardRef as ReactComponent };